export default __webpack_public_path__ + "static/summer_containers39-737f3c529e91fdeb6d3ad011929636f9.webp";